var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('reports-header',{attrs:{"enableImports":_vm.enableImports},model:{value:(_vm.currentAction),callback:function ($$v) {_vm.currentAction=$$v},expression:"currentAction"}}),(_vm.isReports)?_c('reports-table'):_vm._e(),(_vm.isImports)?_c('imports-table'):_vm._e(),_c('router-view'),_c('warning-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }